// imageLoader.js

import { getCurrentInstance } from 'vue';
// import enhome_imagetrans_button from '@/assets/painting/en/first_imagetrans_buttom_en.jpg';
// import enhome_premodels_button from '@/assets/painting/en/first_premodels_button_en.jpg';
// 自定义页面按钮
import enimagetrans_assemble_button from '@/assets/painting/en/imagetrans_assemble_button_en.jpg';
import enimagetrans_upload_button from '@/assets/painting/en/imagetrans_upload_button_en.jpg';
// // 自定义页面顶图
import enimagetrans_topdetail_fusebeads from '@/assets/painting/en/fusebeads_topdetail_en.jpg';

import enimagetrans_topdetail_colorbrick_gray from '@/assets/painting/en/colorbrick_topdetail_gray_en.jpg';
import enimagetrans_topdetail_colorbrick_orange from '@/assets/painting/en/colorbrick_topdetail_orange_en.jpg';
import enimagetrans_topdetail_colorbrick_pink from '@/assets/painting/en/colorbrick_topdetail_pink_en.jpg';
import enimagetrans_topdetail_littlebrick from '@/assets/painting/en/littlebrick_topdetail_en.jpg';
import enimagetrans_topdetail_microbrick from '@/assets/painting/en/microbrick_topdetail_en.jpg';
import enimagetrans_topdetail_diamondpainting from '@/assets/painting/en/diamondpainting_topdetail_en.jpg';
import enimagetrans_topdetail_romantic from '@/assets/painting/en/romantic_topdetail_en.jpg';

// 裁剪图像路径
import enromantic_crop_square from '@/assets/painting/en/romantic_crop_square_en.png';
import enromantic_crop_horizontal from '@/assets/painting/en/romantic_crop_horizontal_en.png';
import enromantic_crop_vertical from '@/assets/painting/en/romantic_crop_vertical_en.png';

import endiamond_crop_square from '@/assets/painting/en/diamond_crop_square_en.png';
import endiamond_crop_horizontal from '@/assets/painting/en/diamond_crop_horizontal_en.png';
import endiamond_crop_vertical from '@/assets/painting/en/diamond_crop_vertical_en.png';


// 中文
// import zhhome_imagetrans_button from '@/assets/painting/zh/first_imagetrans_button_zh.jpg';
// import zhhome_premodels_button from '@/assets/painting/zh/first_premodels_button_zh.jpg';

import zhimagetrans_assemble_button from '@/assets/painting/zh/imagetrans_assemble_button_zh.jpg';
import zhimagetrans_upload_button from '@/assets/painting/zh/imagetrans_upload_button_zh.jpg';
import zhimagetrans_topdetail_fusebeads from '@/assets/painting/zh/fusebeads_topdetail_zh.jpg';

// 导入其他图像
import zhimagetrans_topdetail_colorbrick_gray from '@/assets/painting/zh/colorbrick_topdetail_gray_zh.jpg';
import zhimagetrans_topdetail_colorbrick_orange from '@/assets/painting/zh/colorbrick_topdetail_orange_zh.jpg';
import zhimagetrans_topdetail_colorbrick_pink from '@/assets/painting/zh/colorbrick_topdetail_pink_zh.jpg';
import zhimagetrans_topdetail_littlebrick from '@/assets/painting/zh/littlebrick_topdetail_zh.jpg';
import zhimagetrans_topdetail_microbrick from '@/assets/painting/zh/microbrick_topdetail_zh.jpg';
import zhimagetrans_topdetail_diamondpainting from '@/assets/painting/zh/diamondpainting_topdetail_zh.jpg';
import zhimagetrans_topdetail_romantic from '@/assets/painting/zh/romantic_topdetail_zh.jpg';

// 裁剪示意图像路径
import zhromantic_crop_square from '@/assets/painting/zh/romantic_crop_square_zh.png';
import zhromantic_crop_horizontal from '@/assets/painting/zh/romantic_crop_horizontal_zh.png';
import zhromantic_crop_vertical from '@/assets/painting/zh/romantic_crop_vertical_zh.png';

import zhdiamond_crop_square from '@/assets/painting/zh/diamond_crop_square_zh.png';  
import zhdiamond_crop_horizontal from '@/assets/painting/zh/diamond_crop_horizontal_zh.png';
import zhdiamond_crop_vertical from '@/assets/painting/zh/diamond_crop_vertical_zh.png';

const imageMap = {
  en: {
    // 'home_imagetrans_button': enhome_imagetrans_button,
    // 'home_premodels_button' : enhome_premodels_button,
    'imagetrans_assemble_button' : enimagetrans_assemble_button,
    'imagetrans_upload_button' : enimagetrans_upload_button,
    'imagetrans_topdetail_fusebeads' : enimagetrans_topdetail_fusebeads,
    'imagetrans_topdetail_colorbrick_gray' : enimagetrans_topdetail_colorbrick_gray,
    'imagetrans_topdetail_colorbrick_orange' : enimagetrans_topdetail_colorbrick_orange,
    'imagetrans_topdetail_colorbrick_pink' : enimagetrans_topdetail_colorbrick_pink,
    'imagetrans_topdetail_littlebrick' : enimagetrans_topdetail_littlebrick,
    'imagetrans_topdetail_microbrick' : enimagetrans_topdetail_microbrick,
    'imagetrans_topdetail_diamondpainting' : enimagetrans_topdetail_diamondpainting,
    'imagetrans_topdetail_romantic' : enimagetrans_topdetail_romantic,
    // 其他图像路径
    'romantic_crop_square': enromantic_crop_square,
    'romantic_crop_horizontal': enromantic_crop_horizontal,
    'romantic_crop_vertical': enromantic_crop_vertical,
    'diamond_crop_square': endiamond_crop_square,
    'diamond_crop_horizontal': endiamond_crop_horizontal,
    'diamond_crop_vertical': endiamond_crop_vertical


  },
  zh: {
    // 'home_imagetrans_button': zhhome_imagetrans_button,
    // 'home_premodels_button' : zhhome_premodels_button,
    'imagetrans_assemble_button' : zhimagetrans_assemble_button,
    'imagetrans_upload_button' : zhimagetrans_upload_button,
    'imagetrans_topdetail_fusebeads' : zhimagetrans_topdetail_fusebeads,
    'imagetrans_topdetail_colorbrick_gray' : zhimagetrans_topdetail_colorbrick_gray,
    'imagetrans_topdetail_colorbrick_orange' : zhimagetrans_topdetail_colorbrick_orange,
    'imagetrans_topdetail_colorbrick_pink' : zhimagetrans_topdetail_colorbrick_pink,
    'imagetrans_topdetail_littlebrick' : zhimagetrans_topdetail_littlebrick,
    'imagetrans_topdetail_microbrick' : zhimagetrans_topdetail_microbrick,
    'imagetrans_topdetail_diamondpainting' : zhimagetrans_topdetail_diamondpainting,
    'imagetrans_topdetail_romantic' : zhimagetrans_topdetail_romantic,
    // 其他图像路径
    'romantic_crop_square': zhromantic_crop_square,
    'romantic_crop_horizontal': zhromantic_crop_horizontal,
    'romantic_crop_vertical': zhromantic_crop_vertical,
    'diamond_crop_square': zhdiamond_crop_square,
    'diamond_crop_horizontal': zhdiamond_crop_horizontal,
    'diamond_crop_vertical': zhdiamond_crop_vertical
  },
  // 其他语言的图像路径
};

export function getLocalImagePath(imageName) {
  const i18n = getCurrentInstance().appContext.config.globalProperties.$i18n;
  const lang = i18n ? i18n.locale : 'en'; // 默认语言为英文
  const images = imageMap[lang];
  return images ? images[imageName] : '';
}
